// extracted by mini-css-extract-plugin
export default {"section_title":"CheckoutForm_section_title__wnZ3r","payment_form":"CheckoutForm_payment_form__022q4","button_checkout":"CheckoutForm_button_checkout__JUigw"};